// React Imports
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Layouts
import AuthLayout from './layouts/AuthLayout';
import DashboardLayout from "./layouts/DashboardLayout";

// Pages
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Verify from "./pages/Verify";
import ResetPassword from "./pages/ResetPassword";

// Auth Pages
import Dashboard from './pages/Dashboard';
import FailedRegisteringWorkspace from "./pages/FailedRegisteringWorkspace";
import Subscribe from "./pages/Subscribe";
import RegisterTeams from "./pages/RegisterTeams";
import RegisterSlack from "./pages/RegisterSlack";
import RegisterDiscord from "./pages/RegisterDiscord";
import RegisterMobile from "./pages/RegisterMobile";
import Settings from "./pages/Settings";
import Analytics from "./pages/Analytics";
import Resubscribe from "./pages/Resubscribe";
import InvoiceFailed from "./pages/InvoiceFailed";

// Components
// Auth Components

// Contexts
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from './contexts/LanguageContext';

export default function App() {

    return (
        <LanguageProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/">
                            {/* Public Routes */}
                            <Route index element={<Navigate to="auth" replace />} />
                            <Route path="login" element={<Login />} />
                            <Route path="signup" element={<Signup />} />
                            <Route path="forgot-password" element={<ForgotPassword />} />
                            <Route path="verify" element={<Verify />} />
                            <Route path="reset-password/:id" element={<ResetPassword />} />
                            {/* FAQ */}

                            {/* Protected Routes */}
                            <Route path="auth" element={<AuthLayout />}>
                                <Route element={<DashboardLayout />}>
                                    <Route index element={<Navigate to="dashboard" />} />
                                    <Route path="dashboard" element={<Dashboard />} />
                                    {/*<Route path=":workspaceId" element={<WorkspaceConfig />} />*/}           
                                    {/*<Route path=":workspaceId" element={<WorkspaceLayout />}>
                                        <Route index element={<WorkspaceConfig />} />
                                    </Route>*/}
                                    {/* Billing */}
                                    <Route path="resubscribe" element={<Resubscribe />} />
                                    <Route path="subscribe" element={<Subscribe />} />
                                    <Route path="invoice-failed" element={<InvoiceFailed />} />

                                    <Route path="failed-registering-workspace" element={<FailedRegisteringWorkspace />} />
                                    <Route path="register-teams" element={<RegisterTeams />} />
                                    <Route path="register-slack" element={<RegisterSlack />} />
                                    <Route path="register-discord" element={<RegisterDiscord />} />
                                    <Route path="register-mobile" element={<RegisterMobile />} />
                                    <Route path="analytics" element={<Analytics />} />

                                    <Route path="settings" element={<Settings />} />
                                </Route>
                            </Route> 

                            {/* 404 */}
                            <Route path="*" element={<NotFound />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </LanguageProvider>
    );
}

